// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAdminImpersonationResult = arrayOf(
  objectOf({
    name: string,
    id: string,
    company_name: string,
    company_id: string,
    user_count: string,
    image_url: string,
  })
);
